// // import { useEffect } from 'react';
// // import {
// //   getNoneInventoryById,
// //   getNoneInventoryList,
// //   receiveNoneInventoryItem
// // } from '@store/purchases/PurchaseBill/purchaseBillSlice';
// // import { useAppDispatch, useAppSelector } from '@store/hooks';
// // import { useTranslation } from 'react-i18next';
// // import { Form } from 'react-bootstrap';
// // import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
// // import Loading from '@components/Shared/Loader/Loading';
// // import CustomAlert from '@components/Shared/Alert/CustomAlert';
// // import { useFormik } from 'formik';
// // import * as Yup from 'yup';
// // import { Can } from '@Permisstions/Can';

// // interface Props {
// //   id: string;
// //   onclose: () => void;
// // }

// // const validationSchema = Yup.object({
// //   receiptDate: Yup.date().required('مطلوب').nullable(),
// //   supplierInvoiceNum: Yup.string().required('مطلوب').nullable()
// // });

// // const Receive = ({ id, onclose }: Props) => {
// //   const { UnitsOfMeasureList, loading: loading2, error: error2 } = useGetUnitsOfMeasureList();

// //   const { t, i18n } = useTranslation();
// //   const dispatch = useAppDispatch();
// //   useEffect(() => {
// //     dispatch(getNoneInventoryById(id));
// //   }, [dispatch, id]);
// //   const { NoneInventoryById: data, loadingNoneInventoryById, error } = useAppSelector(a => a.PurchaseBill);

// //   const formik = useFormik({
// //     initialValues: {
// //       id: '',
// //       receiptNote: '',
// //       supplierInvoiceNum: '',
// //       receiptDate: ''
// //     },

// //     validationSchema,

// //     onSubmit: values => {
// //       dispatch(
// //         receiveNoneInventoryItem({
// //           id: data.id,
// //           receiptNote: values.receiptNote,
// //           supplierInvoiceNum: values.supplierInvoiceNum,
// //           receiptDate: values.receiptDate
// //         })
// //       )
// //         .unwrap()
// //         .then(res => {
// //           if (res.succeeded === true) {
// //             CustomAlert({ action: 'Add', msg: 'تم عملية الإستلام بنجاح' });
// //             dispatch(getNoneInventoryList());
// //             onclose();
// //           } else {
// //             CustomAlert({ action: 'Error' });
// //           }
// //         })
// //         .catch(error => {
// //           CustomAlert({ action: 'Error' });
// //         })
// //         .finally(() => formik.setSubmitting(false));
// //     }
// //   });
// //   return (
// //     <>
// //       <Loading loading={loadingNoneInventoryById || loading2} error={error || error2} Type='Dots'>
// //         <div className={`table-responsive rounded-2 text-center  mb-4`}>
// //           <table className='table   text-nowrap  table-hover mb-0'>
// //             <thead className='bg-theme bg-opacity-30'>
// //               <tr>
// //                 <th className='align-middle  small' style={{ width: '2%' }}>
// //                   #
// //                 </th>

// //                 <th className='align-middle small' style={{ width: '30%' }}>
// //                   {t('الوصف')}
// //                 </th>
// //                 <th className='align-middle  small' style={{ width: '10%' }}>
// //                   {t('الوحدة')}
// //                 </th>
// //                 <th className='align-middle  small' style={{ width: '5%' }}>
// //                   {t('الكمية')}
// //                 </th>
// //               </tr>
// //             </thead>

// //             <tbody className='fw-bold'>
// //               {data?.transactionsLinesList?.slice()?.map((line, index) => {
// //                 return (
// //                   <tr key={index}>
// //                     <td className='align-middle text-theme'>{++index}</td>

// //                     <td className='align-middle '>{line.description}</td>

// //                     <td className='align-middle '>
// //                       {i18n.language === 'en'
// //                         ? UnitsOfMeasureList.find(f => f.id === line.uom)?.name
// //                         : UnitsOfMeasureList.find(f => f.id === line.uom)?.name2}
// //                     </td>

// //                     <td className='align-middle '>{line.qty}</td>
// //                   </tr>
// //                 );
// //               })}
// //             </tbody>
// //           </table>
// //         </div>

// //         <Form onSubmit={formik.handleSubmit}>
// //           <div className='row mb-3'>
// //             <div className='col-lg-3'>
// //               <div className='form-group mb-3'>
// //                 <label className='form-label'>{t('تاريخ الإستلام')}</label>
// //                 <Form.Control
// //                   className='form-control fw-bold'
// //                   type='date'
// //                   autoComplete='off'
// //                   name='receiptDate'
// //                   onChange={formik.handleChange}
// //                   value={formik.values.receiptDate}
// //                   isInvalid={!!(formik.touched.receiptDate && formik.errors.receiptDate)}
// //                 />
// //                 <Form.Control.Feedback type='invalid'>{formik.errors.receiptDate}</Form.Control.Feedback>
// //               </div>
// //             </div>
// //             <div className='col-lg-9'>
// //               <div className='form-group mb-3'>
// //                 <label className='form-label'>{t('Note')}</label>
// //                 <Form.Control
// //                   className='form-control fw-bold'
// //                   type='text'
// //                   autoComplete='off'
// //                   name='receiptNote'
// //                   onChange={formik.handleChange}
// //                   value={formik.values.receiptNote}
// //                   isInvalid={!!(formik.touched.receiptNote && formik.errors.receiptNote)}
// //                 />
// //                 <Form.Control.Feedback type='invalid'>{formik.errors.receiptNote}</Form.Control.Feedback>
// //               </div>
// //             </div>
// //           </div>

// //           <div className='text-center'>
// //             <Can permission={'PURReceiveNoneInventoryItem'}>
// //               <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1 '>
// //                 {formik.isSubmitting ? (
// //                   <div className='spinner-border spinner-border-sm me-2'></div>
// //                 ) : (
// //                   <i className='fas fa-lg fa-fw me-2 fa-receipt'></i>
// //                 )}
// //                 {t('إستـــلام')}
// //               </button>
// //             </Can>
// //             <button type='button' className=' btn  btn-lg me-1 btn-default mb-1' onClick={onclose}>
// //               <i className='fas fa-times fa-fw me-1'></i>
// //               {t('Cancel')}
// //             </button>
// //           </div>
// //         </Form>
// //       </Loading>
// //     </>
// //   );
// // };

// // export default Receive;

// import { useEffect } from 'react';
// import {
//   getNoneInventoryById,
//   getNoneInventoryList,
//   receiveNoneInventoryItem
// } from '@store/purchases/PurchaseBill/purchaseBillSlice';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { useTranslation } from 'react-i18next';
// import { Form } from 'react-bootstrap';
// import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
// import Loading from '@components/Shared/Loader/Loading';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { Can } from '@Permisstions/Can';

// interface Props {
//   id: string;
//   onclose: () => void;
// }

// // تعريف الواجهة لبيانات الخطوط
// interface TransactionLine {
//   id: string;
//   description: string;
//   uom: string;
//   qty: number;
//   // يمكن إضافة المزيد من الخصائص حسب الحاجة
// }

// // تعريف الواجهة لبيانات الفاتورة
// interface NoneInventoryData {
//   id: string;
//   transactionsLinesList: TransactionLine[];
//   // يمكن إضافة المزيد من الخصائص حسب الحاجة
// }

// // تعريف القيم الأولية للنموذج
// interface FormValues {
//   id: string;
//   receiptNote: string;
//   supplierInvoiceNum: string;
//   receiptDate: string;
// }

// const validationSchema = Yup.object({
//   receiptDate: Yup.date().required('مطلوب').nullable(),
//   supplierInvoiceNum: Yup.string().required('مطلوب').nullable(),
//   receiptNote: Yup.string().optional()
// });

// const Receive = ({ id, onclose }: Props) => {
//   const { UnitsOfMeasureList, loading: loadingUnits, error: unitsError } = useGetUnitsOfMeasureList();

//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   // جلب بيانات الفاتورة عند تحميل المكون
//   useEffect(() => {
//     if (id) {
//       dispatch(getNoneInventoryById(id));
//     }
//   }, [dispatch, id]);

//   const {
//     NoneInventoryById: data,
//     loadingNoneInventoryById,
//     error: invoiceError
//   } = useAppSelector(state => state.PurchaseBill);

//   // تهيئة النموذج
//   const formik = useFormik<FormValues>({
//     initialValues: {
//       id: id || '',
//       receiptNote: '',
//       supplierInvoiceNum: '',
//       receiptDate: new Date().toISOString().split('T')[0] // التاريخ الحالي كقيمة افتراضية
//     },

//     validationSchema,

//     onSubmit: values => {
//       if (!data?.id) {
//         CustomAlert({ action: 'Error', msg: 'بيانات الفاتورة غير متوفرة' });
//         return;
//       }

//       dispatch(
//         receiveNoneInventoryItem({
//           id: data.id,
//           receiptNote: values.receiptNote,
//           supplierInvoiceNum: values.supplierInvoiceNum,
//           receiptDate: values.receiptDate
//         })
//       )
//         .unwrap()
//         .then(res => {
//           if (res.succeeded === true) {
//             CustomAlert({
//               action: 'Add',
//               msg: t('تم عملية الإستلام بنجاح') || 'تم عملية الإستلام بنجاح'
//             });
//             dispatch(getNoneInventoryList());
//             onclose();
//           } else {
//             CustomAlert({
//               action: 'Error',
//               msg: res.message || t('حدث خطأ أثناء الإستلام')
//             });
//           }
//         })
//         .catch(error => {
//           CustomAlert({
//             action: 'Error',
//             msg: error.message || t('حدث خطأ غير متوقع')
//           });
//         })
//         .finally(() => formik.setSubmitting(false));
//     },

//     enableReinitialize: true // إعادة تهيئة القيم عند تغيير data
//   });

//   // دالة للحصول على اسم وحدة القياس
//   const getUnitName = (unitId: string): string => {
//     const unit = UnitsOfMeasureList.find(f => f.id === unitId);
//     if (!unit) return unitId;

//     return i18n.language === 'en' ? unit.name : unit.name2 || unit.name;
//   };

//   // حالة التحميل
//   const isLoading = loadingNoneInventoryById || loadingUnits;
//   const hasError = invoiceError || unitsError;

//   return (
//     <>
//       <Loading loading={isLoading} error={hasError} Type='Dots'>
//         {/* جدول تفاصيل الفاتورة */}
//         <div className={`table-responsive rounded-2 text-center mb-4`}>
//           <table className='table text-nowrap table-hover mb-0'>
//             <thead className='bg-theme bg-opacity-30'>
//               <tr>
//                 <th className='align-middle small' style={{ width: '5%' }}>
//                   #
//                 </th>
//                 <th className='align-middle small' style={{ width: '45%' }}>
//                   {t('الوصف')}
//                 </th>
//                 <th className='align-middle small' style={{ width: '20%' }}>
//                   {t('الوحدة')}
//                 </th>
//                 <th className='align-middle small' style={{ width: '10%' }}>
//                   {t('الكمية')}
//                 </th>
//               </tr>
//             </thead>

//             <tbody className='fw-bold'>
//               {data?.transactionsLinesList?.length > 0 ? (
//                 data.transactionsLinesList.map((line: any, index: number) => (
//                   <tr key={line.id || index}>
//                     <td className='align-middle text-theme'>{index + 1}</td>
//                     <td className='align-middle'>{line.description}</td>
//                     <td className='align-middle'>{getUnitName(line.uom)}</td>
//                     <td className='align-middle'>{line.qty}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan={4} className='text-center py-4'>
//                     {t('لا توجد عناصر في هذه الفاتورة')}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* نموذج الإستلام */}
//         <Form onSubmit={formik.handleSubmit}>
//           <div className='row mb-3'>
//             {/* حقل تاريخ الاستلام */}
//             <div className='col-md-4 col-lg-3'>
//               <div className='form-group mb-3'>
//                 <label className='form-label fw-bold'>{t('تاريخ الإستلام')} *</label>
//                 <Form.Control
//                   className='form-control'
//                   type='date'
//                   autoComplete='off'
//                   name='receiptDate'
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.receiptDate}
//                   isInvalid={!!(formik.touched.receiptDate && formik.errors.receiptDate)}
//                   disabled={formik.isSubmitting}
//                 />
//                 <Form.Control.Feedback type='invalid'>
//                   {formik.errors.receiptDate}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             {/* حقل رقم فاتورة المورد */}
//             <div className='col-md-4 col-lg-3'>
//               <div className='form-group mb-3'>
//                 <label className='form-label fw-bold'>{t('رقم فاتورة المورد')} *</label>
//                 <Form.Control
//                   className='form-control'
//                   type='text'
//                   autoComplete='off'
//                   name='supplierInvoiceNum'
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.supplierInvoiceNum}
//                   isInvalid={!!(formik.touched.supplierInvoiceNum && formik.errors.supplierInvoiceNum)}
//                   placeholder={t('أدخل رقم الفاتورة')}
//                   disabled={formik.isSubmitting}
//                 />
//                 <Form.Control.Feedback type='invalid'>
//                   {formik.errors.supplierInvoiceNum}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             {/* حقل الملاحظة */}
//             <div className='col-md-4 col-lg-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label fw-bold'>{t('ملاحظات')}</label>
//                 <Form.Control
//                   className='form-control'
//                   type='text'
//                   autoComplete='off'
//                   name='receiptNote'
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.receiptNote}
//                   isInvalid={!!(formik.touched.receiptNote && formik.errors.receiptNote)}
//                   placeholder={t('أدخل ملاحظات حول الإستلام')}
//                   disabled={formik.isSubmitting}
//                 />
//                 <Form.Control.Feedback type='invalid'>
//                   {formik.errors.receiptNote}
//                 </Form.Control.Feedback>
//               </div>
//             </div>
//           </div>

//           {/* أزرار التنفيذ */}
//           <div className='text-center'>
//             <Can permission={'PURReceiveNoneInventoryItem'}>
//               <button
//                 disabled={formik.isSubmitting || !formik.isValid || !data}
//                 type='submit'
//                 className='btn btn-lg me-2 btn-theme mb-1'
//               >
//                 {formik.isSubmitting ? (
//                   <>
//                     <span className='spinner-border spinner-border-sm me-2'></span>
//                     {t('جاري الإستلام...')}
//                   </>
//                 ) : (
//                   <>
//                     <i className='fas fa-lg fa-fw me-2 fa-receipt'></i>
//                     {t('إستـــلام')}
//                   </>
//                 )}
//               </button>
//             </Can>
//             <button
//               type='button'
//               className='btn btn-lg btn-default mb-1'
//               onClick={onclose}
//               disabled={formik.isSubmitting}
//             >
//               <i className='fas fa-times fa-fw me-1'></i>
//               {t('إلغاء')}
//             </button>
//           </div>

//         </Form>
//       </Loading>
//     </>
//   );
// };

// export default Receive;

import { useEffect, useState } from 'react';
import {
  getNoneInventoryById,
  getNoneInventoryList,
  receiveNoneInventoryItem
} from '@store/purchases/PurchaseBill/purchaseBillSlice';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
import Loading from '@components/Shared/Loader/Loading';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import confirmAction from '@components/Shared/Alert/confirmAction';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Can } from '@Permisstions/Can';
import { Card, CardBody, CardHeader, CardFooter } from '@components/card/card';

interface Props {
  id: string;
  onclose: () => void;
}

interface TransactionLine {
  id: string;
  description: string;
  uom: string;
  qty: number;
}

interface NoneInventoryData {
  id: string;
  code: string;
  date: string;
  supplierName: string;
  supplierName2: string;
  supplierCode?: string;
  totalAmount?: number;
  transactionsLinesList: TransactionLine[];
}

interface FormValues {
  id: string;
  receiptNote: string;
  supplierInvoiceNum: string;
  receiptDate: string;
}

const validationSchema = Yup.object({
  receiptDate: Yup.date().required('مطلوب').nullable(),
  supplierInvoiceNum: Yup.string().required('مطلوب').nullable(),
  receiptNote: Yup.string().optional()
});

const Receive = ({ id, onclose }: Props) => {
  const { UnitsOfMeasureList, loading: loadingUnits, error: unitsError } = useGetUnitsOfMeasureList();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(getNoneInventoryById(id));
    }
  }, [dispatch, id]);

  const {
    NoneInventoryById: data,
    loadingNoneInventoryById,
    error: invoiceError
  } = useAppSelector(state => state.PurchaseBill);

  const formik = useFormik<FormValues>({
    initialValues: {
      id: id || '',
      receiptNote: '',
      supplierInvoiceNum: data ? data.supplierInvoiceNum : '',
      receiptDate: new Date().toISOString().split('T')[0]
    },
    enableReinitialize: true,
    validationSchema,

    onSubmit: async values => {
      const confirm = await confirmAction(t('هل أنت متأكد من العملية'));
      if (!confirm) return;

      if (!data?.id) {
        CustomAlert({ action: 'Error', msg: 'بيانات الفاتورة غير متوفرة' });
        return;
      }

      setIsSubmitting(true);
      dispatch(
        receiveNoneInventoryItem({
          id: data.id,
          receiptNote: values.receiptNote,
          supplierInvoiceNum: values.supplierInvoiceNum,
          receiptDate: values.receiptDate
        })
      )
        .unwrap()
        .then(res => {
          if (res.succeeded === true) {
            CustomAlert({
              action: 'Add',
              msg: t('تم عملية الإستلام بنجاح') || 'تم عملية الإستلام بنجاح',
              Timer: 5000
            });
            dispatch(getNoneInventoryList());
            onclose();
          } else {
            CustomAlert({
              action: 'Error',
              msg: res.message || t('حدث خطأ أثناء الإستلام')
            });
          }
        })
        .catch(error => {
          CustomAlert({
            action: 'Error',
            msg: error.message || t('حدث خطأ غير متوقع')
          });
        })
        .finally(() => {
          formik.setSubmitting(false);
          setIsSubmitting(false)
        });
    }
  });

  const getUnitName = (unitId: string): string => {
    const unit = UnitsOfMeasureList.find(f => f.id === unitId);
    if (!unit) return unitId;
    return i18n.language === 'en' ? unit.name : unit.name2 || unit.name;
  };

  const isLoading = loadingNoneInventoryById || loadingUnits;
  const hasError = invoiceError || unitsError;

  const formatAmount = (amount?: number) => {
    if (!amount) return '0.00';
    return new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <>
      <div className='p-0'>
        {/* رأس الصفحة */}
        <div className='d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom'>
          <div>
            <h4 className='m-0 text-theme fw-bold'>
              <i className='fas fa-box-check me-2'></i>
              {t('معالجة العمليـات الغير مخزنية')}
            </h4>
          </div>
          <button
            type='button'
            className='btn btn-outline-secondary btn-sm'
            onClick={onclose}
            disabled={formik.isSubmitting}
          >
            <i className='fas fa-times me-1'></i>
            {t('Close')}
          </button>
        </div>

        {/* بطاقة معلومات الفاتورة */}
        <div className='mb-4'>
          <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
            <CardBody className='d-flex align-items-center p-3'>
              <i className='fas fa-file-invoice fa-2x text-primary me-3'></i>
              <div className='flex-grow-1'>
                <h4 className='text-primary mb-0'>#{data?.code || ''}</h4>
                {/* <p className='text-muted mb-0'>
                  {data?.supplierName2 || data?.supplierName} {data?.supplierCode ? `(${data.supplierCode})` : ''}
                </p> */}
              </div>
              <div className='text-end'>
                <div className='badge bg-theme p-2'>
                  <i className='fas fa-cubes me-1'></i>
                  {data?.transactionsLinesList?.length || 0} صنف
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        <Loading loading={isLoading} error={hasError} Type='Dots'>
          {/* تفاصيل الفاتورة */}
          <Card className='mb-4 border-0 shadow-sm'>
            <CardHeader className='d-flex justify-content-between align-items-center bg-transparent border-0'>
              <h5 className='mb-0'>
                <i className='fas fa-list-check me-2 text-theme'></i>
                الأصناف
                <span className='badge bg-primary ms-2'>{data?.transactionsLinesList?.length || 0}</span>
              </h5>
            </CardHeader>

            <CardBody className='p-0'>
              <div className='table-responsive' style={{ maxHeight: '300px' }}>
                <table className='table table-hover mb-0'>
                  <thead
                    className='table-active fw-bold'
                    style={{
                      position: 'sticky',
                      top: 0,
                      zIndex: 101,
                      backdropFilter: 'blur(30px)'
                    }}
                  >
                    <tr>
                      <th className='text-center small'>#</th>
                      <th className='text-  small'>الصنف</th>
                      <th className='text-center small'>الوحدة</th>
                      <th className='text-center small'>الكمية</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.transactionsLinesList?.map((line, index) => (
                      <tr key={line.id || index}>
                        <td className='text-center align-middle'>
                          <strong className='text-theme'>{index + 1}</strong>
                        </td>
                        <td className='align-middle'>
                          <strong>{line.description}</strong>
                        </td>
                        <td className='text-center align-middle'>
                          <span className='badge bg-info'>{getUnitName(line.uom)}</span>
                        </td>
                        <td className='text-center align-middle'>
                          <span className='fw-bold text-theme'>{line.qty}</span>
                        </td>
                      </tr>
                    ))}

                    {(!data?.transactionsLinesList || data.transactionsLinesList.length === 0) && (
                      <tr>
                        <td colSpan={4} className='text-center py-4 text-muted'>
                          <i className='fa fa-inbox fa-2x mb-2'></i>
                          <br />
                          {t('لا توجد أصناف')}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </CardBody>

            <CardFooter className='d-flex justify-content-between align-items-center bg-transparent'>
              <div className='text-muted small'>
                عرض {data?.transactionsLinesList?.length || 0} من {data?.transactionsLinesList?.length || 0} صنف
              </div>
            </CardFooter>
          </Card>

          {/* نموذج الإستلام */}
          <Form onSubmit={formik.handleSubmit}>
            <Card className='border-0 shadow-sm'>
              {/* <CardHeader className='bg-transparent border-0'>
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <h5 className='m-0 text-theme'>
                      <i className='fas fa-clipboard-list me-2'></i>
                      {t('معلومات الإستلام')}
                    </h5>
                  </div>
              
                </div>
              </CardHeader> */}

              <CardBody>
                <div className='row mb-4'>
                  {/* حقل تاريخ الاستلام */}
                  <div className='col-md-6 col-lg-4 mb-3'>
                    <div className='form-group'>
                      <label className='form-label fw-bold'>
                        {t('التاريخ ')} <span className='text-danger'>*</span>
                      </label>
                      <Form.Control
                        className='form-control'
                        type='date'
                        autoComplete='off'
                        name='receiptDate'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.receiptDate}
                        isInvalid={!!(formik.touched.receiptDate && formik.errors.receiptDate)}
                        disabled={formik.isSubmitting}
                      />
                      <Form.Control.Feedback type='invalid'>{formik.errors.receiptDate}</Form.Control.Feedback>
                    </div>
                  </div>

                  {/* حقل رقم فاتورة المورد */}
                  <div className='col-md-6 col-lg-4 mb-3'>
                    <div className='form-group'>
                      <label className='form-label fw-bold'>
                        {t('الرقم المرجعي')} <span className='text-danger'>*</span>
                      </label>
                      <Form.Control
                        className='form-control'
                        type='text'
                        autoComplete='off'
                        name='supplierInvoiceNum'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.supplierInvoiceNum}
                        isInvalid={!!(formik.touched.supplierInvoiceNum && formik.errors.supplierInvoiceNum)}
                        // placeholder={t('أدخل رقم الفاتورة')}
                        disabled={formik.isSubmitting}
                      />
                      <Form.Control.Feedback type='invalid'>{formik.errors.supplierInvoiceNum}</Form.Control.Feedback>
                    </div>
                  </div>

                  {/* حقل الملاحظة */}
                  <div className='col-lg-4 mb-3'>
                    <div className='form-group'>
                      <label className='form-label fw-bold'>{t('ملاحظات')}</label>
                      <Form.Control
                        className='form-control'
                        type='text'
                        autoComplete='off'
                        name='receiptNote'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.receiptNote}
                        isInvalid={!!(formik.touched.receiptNote && formik.errors.receiptNote)}
                        // placeholder={t('أدخل ملاحظات حول الإستلام')}
                        disabled={formik.isSubmitting}
                      />
                      <Form.Control.Feedback type='invalid'>{formik.errors.receiptNote}</Form.Control.Feedback>
                    </div>
                  </div>
                </div>

                {/* أزرار الإجراء */}
              </CardBody>
            </Card>
            <div className='mt-4'>
              <div className='row g-3'>
                <div className='col-md-6'>
                  <Can permission={'PURReceiveNoneInventoryItem'}>
                    <button
                      type='submit'
                      className='btn btn-theme w-100 py-3 d-flex align-items-center justify-content-center'
                      disabled={formik.isSubmitting || !formik.isValid || !data || isSubmitting}
                    >
                      {formik.isSubmitting ? (
                        <>
                          <div className='spinner-border spinner-border-sm me-2'></div>
                          {t('جاري الإستلام...')}
                        </>
                      ) : (
                        <>
                          <i className='fas fa-box-check me-2 fa-lg'></i>
                          <div className='d-flex flex-column align-items-start'>
                            <span className='fw-bold'>{t('إستـــلام')}</span>
                          </div>
                        </>
                      )}
                    </button>
                  </Can>
                </div>
                <div className='col-md-6'>
                  <button
                    type='button'
                    className='btn btn-outline-secondary w-100 py-3 d-flex align-items-center justify-content-center'
                    onClick={onclose}
                    disabled={formik.isSubmitting}
                  >
                    <i className='fas fa-times me-2'></i>
                    <span className='fw-bold'>{t('إلغاء')}</span>
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </Loading>
      </div>
    </>
  );
};

export default Receive;
